module.exports = __webpack_public_path__ + "static/media/app-wbd.8eba9a2c.svg";